import React, { Component } from 'react';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';

import { Auth } from '../auth';
import { withAuth } from '../auth';
import { withFirebase } from '../firebase';

export class HeaderBase extends Component {

  static UserPanelStyle = {
    display: 'flex',
    color: 'white',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '10px',
  }

  logOut = () => {
    this.props.auth.updateUser(null);
  }

  goToPanel = () => {
    this.props.history.push('/panel');
  }

  render() {
    const { user } = this.props.auth;

    return (
      <header className="mdl-layout__header mdl-color-text--white mdl-color--primary-dark">
        <div className="mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-grid">
          <div className="mdl-layout__header-row mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet mdl-cell--6-col-desktop">
            <Link to="/">
              <div style={{ display: 'flex', alignItems: 'center'}}>
                <div style={{ marginRight: '24px', marginBottom: '4px'}}>
                  <img className="logo" src="/logo_s.png" alt="VoteChain"></img>
                </div>
                <h3 style={{color: 'white'}}>VoteChain</h3>
              </div>
            </Link>
          </div>
          <div className="mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet mdl-cell--6-col-desktop" style={HeaderBase.UserPanelStyle}>
            {
              user ?
              <Link to="/panel">
                <button className="mdl-button mdl-js-button mdl-button--raised mdl-button--accent">
                  My Polls
                </button>
              </Link>
              :
              null
            }
            <div>
              {
                !user ?
                <Auth /> :
                <div>
                  <button className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" style={{marginLeft: '18px'}} onClick={this.logOut}>
                    <i className="material-icons">power_settings_new</i>
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </header>
    );
  }
};

export const Header = compose(withFirebase, withAuth)(HeaderBase);
